import React from "react";

function AccessDeniedPage() {
    return (
        <div className="container my-5">
            <div className="row justify-content-center">
                <div className="col-md-6 text-center">
                    <h1 className="mb-3">Zugriff verweigert</h1>
                    <p>Sie haben keine Berechtigung, auf diese Seite zuzugreifen.</p>
                </div>
            </div>
        </div>
    );
}

export default AccessDeniedPage;
